'use strict';

const jQuery = require('jquery');
const mediator = require('./../../core/mediator');
const container = require('./../../core/container');

const Menu = require('./menu');

const tplDesktop = require('./templates/structure.hbs');
const tplMobile = require('./templates/structure.mobile.hbs');

module.exports.init = function() {
  let $toolbar = container.get('$toolbar');
  let $fullPanel;

  if (container.get('isMobile')) {
    jQuery('body').addClass('is-mobile');
    $toolbar.addClass('is-mobile');
    $toolbar.html(tplMobile());
  } else {
    jQuery('body').addClass('is-desktop');
    $toolbar.addClass('is-desktop');
    $toolbar.html(tplDesktop());
  }

  container.set('language', jQuery('html').attr('lang'));
  container.set('page.uid', $toolbar.data('page-uid'));
  container.set('page.is_online', $toolbar.data('page-online'));
  container.set('image-domain', $toolbar.data('image-domain'));
  container.set('multi-language', $toolbar.data('multi-language'));

  container.set('$smallPanel', $toolbar.find('.cloud-panel'));

  $fullPanel = $toolbar.find('.cloud-panel-fullpage');

  if ($fullPanel.length > 0) {
    container.set('$fullPanel', $fullPanel);
  }

  setTimeout(function() {
    Menu.show();
  }, 1000);

  mediator.publish('structure:ready');
};
